import { __spreadArray, __assign } from '../../../../../_virtual/_tslib.js';
import { COMMENTS_ORDER } from '../../../../../constants/BrandedCommunity/Comments.js';
import { useState } from 'react';
import { useToggleState } from '../../../../common/dataTypes/boolean.js';
import { checkIsFunction } from '../../../../common/dataTypes/function.js';
import { getErrorMessageFromApiError } from '../../../../common/api.js';
import { checkIsArrayEmpty } from '../../../../common/dataTypes/array.js';
import { COMMENT_STATUS } from '../../../../../features/Offerings/modules/RecordedContent/CommentSection/CommentSection.data.js';

var page_sizes = {
    first_call: 3,
    subsequent_calls: 10,
};
var useCommentsList = function (_a) {
    var commentsOrder = _a.commentsOrder, userUuid = _a.userUuid, isCreator = _a.isCreator, highlightedComment = _a.highlightedComment, setHighlightedComment = _a.setHighlightedComment, highlightedReply = _a.highlightedReply, setHighlightedReply = _a.setHighlightedReply, callSubmitApi = _a.callSubmitApi, onSubmitSuccess = _a.onSubmitSuccess, callGetCommentsApi = _a.callGetCommentsApi, callLikeApi = _a.callLikeApi, callEditApi = _a.callEditApi, callDeleteApi = _a.callDeleteApi, notifySuccess = _a.notifySuccess, notifyError = _a.notifyError;
    var _b = useToggleState(false), isLoading = _b[0], startLoading = _b[1], stopLoading = _b[2];
    var _c = useState(undefined), totalComments = _c[0], setTotalComments = _c[1];
    var _d = useState([]), data = _d[0], setData = _d[1];
    var _e = useState(0), page = _e[0], setPage = _e[1];
    var _f = useState(page_sizes.first_call), pageSize = _f[0], setPageSize = _f[1];
    /**
     * This function is can be used for reloading the comments to page 1 and initial state.
     * It sets the loading state, fetches comments, and updates the local state with the new comments.
     * It also accepts an optional success callback to be executed after the comments are successfully loaded.
     * */
    var reloadComments = function (args) {
        if (args === void 0) { args = {}; }
        if (isLoading)
            return;
        startLoading();
        var newPageSize = page_sizes.first_call;
        var newPage = 1;
        callGetCommentsApi({ page: newPage, page_size: newPageSize })
            .then(function (response) {
            var responseData = (response === null || response === void 0 ? void 0 : response.data) || {}; // Get response data
            var newData = responseData.comments || []; // Extract comments
            var newTotalComments = responseData.total || 0; // Extract total comments count
            setPageSize(newPageSize); // Update the local page size state
            setTotalComments(newTotalComments); // Update the total comments count
            setData(__spreadArray([], newData, true)); // Set the new comments data
            setPage(newPage); // Reset to the first page
            if (args.successCallback)
                args.successCallback(); // Call success callback if provided
        })
            .catch(function (e) {
            notifyError(getErrorMessageFromApiError(e) ||
                "An error occured, please try after some time");
        })
            .finally(stopLoading);
    };
    var loadComments = function (args) {
        if (args === void 0) { args = {}; }
        if (isLoading)
            return;
        startLoading();
        // initial
        var newPage = 0;
        var newPageSize = page_sizes.first_call;
        if (page === 0) {
            // fetch first page with page size 3
            newPage = 1;
            newPageSize = page_sizes.first_call;
        }
        else if (page === 1 && pageSize === page_sizes.first_call) {
            // fetch first page with page size 10
            newPage = 1;
            newPageSize = page_sizes.subsequent_calls;
        }
        else {
            newPage = page + 1;
            newPageSize = page_sizes.subsequent_calls;
        }
        callGetCommentsApi({ page: newPage, page_size: newPageSize })
            .then(function (response) {
            var responseData = (response === null || response === void 0 ? void 0 : response.data) || {};
            var newData = responseData.comments || [];
            var newTotalComments = responseData.total || 0;
            setPageSize(newPageSize);
            setTotalComments(newTotalComments);
            if (newPage === 1) {
                setData(__spreadArray([], newData, true));
            }
            else {
                setData(__spreadArray(__spreadArray([], data, true), newData, true));
            }
            if (args.successCallback)
                args.successCallback();
            setPage(newPage);
        })
            .catch(function (e) {
            notifyError(getErrorMessageFromApiError(e) ||
                "An error occured, please try after some time");
        })
            .finally(stopLoading);
    };
    var onSubmit = function (_a) {
        var comment_body = _a.comment_body, attachments = _a.attachments, successCallback = _a.successCallback;
        if (isLoading)
            return;
        var processedCommentBody = (comment_body || "").trim();
        /**
         * Since attachments are introduced so a comment minimum criteria is either
         * it should have a comment text or should have some attachments.
         */
        var isMinimumCommentCriteriaMissed = !processedCommentBody && checkIsArrayEmpty(attachments);
        if (isMinimumCommentCriteriaMissed) {
            notifyError("Comment cannot be empty!");
            return;
        }
        startLoading();
        callSubmitApi({ comment: processedCommentBody, attachments: attachments })
            .then(function () {
            // COMMENTS
            // refetch page 1
            if (commentsOrder === COMMENTS_ORDER.DESCENDING) {
                // initial
                var newPage_1 = 0;
                var newPageSize_1 = page_sizes.first_call;
                if (data.length < page_sizes.first_call) {
                    // fetch first page with page size 3
                    newPage_1 = 1;
                    newPageSize_1 = page_sizes.first_call;
                }
                else {
                    // fetch first page with page size 10
                    newPage_1 = 1;
                    newPageSize_1 = page_sizes.subsequent_calls;
                }
                callGetCommentsApi({
                    page: newPage_1,
                    page_size: newPageSize_1,
                })
                    .then(function (response) {
                    var responseData = (response === null || response === void 0 ? void 0 : response.data) || {};
                    var newData = responseData.comments || [];
                    var newTotalComments = responseData.total || 0;
                    setPageSize(newPageSize_1);
                    setTotalComments(newTotalComments);
                    setData(__spreadArray([], newData, true));
                    setPage(newPage_1);
                    /**Removing the comment from top and reply from top in case someone commented */
                    if (highlightedComment && setHighlightedComment)
                        setHighlightedComment(undefined);
                    if (highlightedReply && setHighlightedReply)
                        setHighlightedReply(undefined);
                })
                    .finally(stopLoading);
            }
            else {
                // REPLIES
                // refetch current page
                /**
                 * TODO: 2 replies list
                 *  1. loaded
                 *  2. posted
                 * on load more, remove items from posted array that are there in newly loaded 10 items
                 */
                var newPage_2 = page;
                if (newPage_2 === 0) {
                    newPage_2 = 1;
                }
                callGetCommentsApi({
                    page: newPage_2,
                    page_size: pageSize,
                })
                    .then(function (response) {
                    var _a;
                    var responseData = (response === null || response === void 0 ? void 0 : response.data) || {};
                    var newDataInResponse = responseData.comments || [];
                    var newTotalComments = responseData.total || 0;
                    setTotalComments(newTotalComments);
                    if (newPage_2 === 1) {
                        setData(__spreadArray([], newDataInResponse, true));
                    }
                    else {
                        var newData = [];
                        var firstCommentUuidInDataArg_1 = (_a = newDataInResponse[0]) === null || _a === void 0 ? void 0 : _a.uuid;
                        var indexToBeReplacedFrom = data.findLastIndex(function (i) { return i.uuid === firstCommentUuidInDataArg_1; });
                        if (indexToBeReplacedFrom >= 0) {
                            newData = __spreadArray(__spreadArray([], data.slice(0, indexToBeReplacedFrom), true), newDataInResponse, true);
                        }
                        setData(newData);
                    }
                })
                    .finally(stopLoading);
            }
            if (onSubmitSuccess && checkIsFunction(onSubmitSuccess))
                onSubmitSuccess();
            if (successCallback && checkIsFunction(successCallback))
                successCallback();
        })
            .catch(function (e) {
            notifyError(getErrorMessageFromApiError(e) ||
                "An error occured, please try after some time");
            stopLoading();
        });
    };
    var _g = useToggleState(), isProcessingComment = _g[0], startProcessingComment = _g[1], stopProcessingComment = _g[2];
    var onLikeClick = function (_a) {
        var comment_uuid = _a.comment_uuid;
        if (isProcessingComment)
            return;
        startProcessingComment();
        callLikeApi({ comment_uuid: comment_uuid })
            .then(function (response) {
            var _a;
            var hasLikedComment = !!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.has_liked);
            var getNewLikesCount = function (comment) {
                var newLikesCount = comment.likes_count;
                if (hasLikedComment !== !!comment.has_liked_comment) {
                    newLikesCount = hasLikedComment
                        ? comment.likes_count + 1
                        : comment.likes_count - 1;
                }
                return newLikesCount;
            };
            /** Updating highlighted Comment and reply in case they are liked */
            if (setHighlightedComment && comment_uuid == (highlightedComment === null || highlightedComment === void 0 ? void 0 : highlightedComment.uuid))
                setHighlightedComment(__assign(__assign({}, highlightedComment), { has_liked_comment: hasLikedComment, likes_count: getNewLikesCount(highlightedComment) }));
            else if (setHighlightedReply && comment_uuid == (highlightedReply === null || highlightedReply === void 0 ? void 0 : highlightedReply.uuid))
                setHighlightedReply(__assign(__assign({}, highlightedReply), { has_liked_comment: hasLikedComment, likes_count: getNewLikesCount(highlightedReply) }));
            else {
                var newData = data.map(function (i) {
                    if (i.uuid !== comment_uuid) {
                        return i;
                    }
                    return __assign(__assign({}, i), { has_liked_comment: hasLikedComment, likes_count: getNewLikesCount(i) });
                });
                setData(newData);
            }
        })
            .catch(function (e) {
            notifyError(getErrorMessageFromApiError(e) ||
                "An error occured, please try after some time");
        })
            .finally(stopProcessingComment);
    };
    var onUpdate = function (_a) {
        var status = _a.status, commentData = _a.commentData, attachments = _a.attachments, successCallback = _a.successCallback;
        /**Either status change is passed from isCreator or user is trying to edit a comment */
        if (!((isCreator && status) || userUuid === commentData.commenter_username))
            return;
        if (isProcessingComment)
            return;
        var processedCommentBody = (commentData.comment || "").trim();
        /**
         * Since attachments are introduced so a comment minimum criteria is either
         * it should have a comment text or should have some attachments.
         */
        var isMinimumCommentCriteriaMissed = !processedCommentBody && checkIsArrayEmpty(attachments);
        if (isMinimumCommentCriteriaMissed) {
            notifyError("Comment cannot be empty!");
            return;
        }
        startProcessingComment();
        callEditApi({
            comment_uuid: commentData.uuid,
            updated_values: {
                comment: processedCommentBody,
                attachments: attachments,
                status: status,
            },
        })
            .then(function () {
            /** Updating highlighted Comment and reply in case they are updated */
            if (setHighlightedComment &&
                commentData.uuid == (highlightedComment === null || highlightedComment === void 0 ? void 0 : highlightedComment.uuid))
                setHighlightedComment(__assign(__assign({}, highlightedComment), { status: status || COMMENT_STATUS.SHOWN, comment: processedCommentBody, attachments: attachments }));
            else if (setHighlightedReply &&
                commentData.uuid == (highlightedReply === null || highlightedReply === void 0 ? void 0 : highlightedReply.uuid))
                setHighlightedReply(__assign(__assign({}, highlightedReply), { status: status || COMMENT_STATUS.SHOWN, comment: processedCommentBody, attachments: attachments }));
            else {
                var newData = __spreadArray([], data, true).map(function (i) {
                    if (i.uuid !== commentData.uuid) {
                        return i;
                    }
                    return __assign(__assign({}, i), { status: status || COMMENT_STATUS.SHOWN, comment: processedCommentBody, attachments: attachments });
                });
                setData(newData);
            }
            successCallback();
            /**Avoid updated notificaiton in case of status update*/
            if (!status)
                notifySuccess("Updated!");
        })
            .catch(function (e) {
            notifyError(getErrorMessageFromApiError(e) ||
                "An error occured, please try after some time");
        })
            .finally(stopProcessingComment);
    };
    var onDelete = function (_a) {
        var commentData = _a.commentData;
        if (!(isCreator || // creator can delete any comment
            userUuid === commentData.commenter_username))
            return;
        if (isProcessingComment)
            return;
        startProcessingComment();
        callDeleteApi({ comment_uuid: commentData.uuid })
            .then(function () {
            notifySuccess("Deleted!");
            /** Deleting highlighted Comment and reply in case they are updated */
            if (setHighlightedComment &&
                commentData.uuid == (highlightedComment === null || highlightedComment === void 0 ? void 0 : highlightedComment.uuid))
                setHighlightedComment(undefined);
            else if (setHighlightedReply &&
                commentData.uuid == (highlightedReply === null || highlightedReply === void 0 ? void 0 : highlightedReply.uuid))
                setHighlightedReply(undefined);
            else {
                var newData = __spreadArray([], data, true).filter(function (i) { return i.uuid !== commentData.uuid; });
                setData(newData);
            }
            if (totalComments) {
                setTotalComments(totalComments - 1);
            }
            /** DEV - Demo Pointer that in case we start deleting comments and
             * length of comments reach less than initial size here case is 3 for better
             * UX we should automatically loadMore if there are more comments available to avoid user efforts */
            if (data.length < page_sizes.first_call &&
                data.length < (totalComments !== null && totalComments !== void 0 ? totalComments : 0))
                loadComments();
        })
            .catch(function (e) {
            notifyError(getErrorMessageFromApiError(e) ||
                "An error occured, please try after some time");
        })
            .finally(stopProcessingComment);
    };
    return {
        onSubmit: onSubmit,
        data: data,
        userUuid: userUuid,
        isCreator: isCreator,
        totalComments: totalComments,
        showLoadMoreCommentsBtn: data.length < (totalComments !== null && totalComments !== void 0 ? totalComments : 0),
        loadComments: loadComments,
        reloadComments: reloadComments,
        onLikeClick: onLikeClick,
        onUpdate: onUpdate,
        onDelete: onDelete,
    };
};

export { useCommentsList };
//# sourceMappingURL=useCommentsList.js.map
